import Sessional from "./Sessional"
import Personal from "./Personal"
import { useState } from "react"


function Questionnaire() {
  const [started, setStarted] = useState(false)


  return (
    !started ?
      <Personal setStarted={setStarted} /> :
      <Sessional />
  )
}

export default Questionnaire